<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="invoices"
      class="mt-1"
      hide-default-footer
      :loading="loading"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.number }}</td>
          <td>{{ props.item.amount_due }}</td>
          <td>{{ props.item.created | moment("YYYY-DD-MM") }}</td>
          <td>
            <span
              v-if="props.item.status === 'paid'"
              class="green--text font-weight-medium"
              >Paid</span
            >
            <span
              v-else-if="props.item.status === 'open'"
              class="blue--text font-weight-medium"
              >Open</span
            >
            <span
              v-else-if="props.item.status === 'draft'"
              class="purple--text font-weight-medium"
              >Draft</span
            >
            <span
              v-else-if="props.item.status === 'uncollectible'"
              class="orange--text font-weight-medium"
              >Uncollectible</span
            >
            <span
              v-else-if="props.item.status === 'void'"
              class="grey--text font-weight-medium"
              >Void</span
            >
            <span v-else>{{ props.item.status }}</span>
          </td>
          <td class="justify-center layout px-0">
            <v-btn
              icon
              :href="props.item.invoice_pdf"
              v-if="props.item.invoice_pdf"
              class="mr-2"
              download
            >
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <v-icon
              v-if="props.item.status === 'paid'"
              class="mr-2"
              @click.stop="creditNotes(props.item.id)"
              >list</v-icon
            >
          </td>
        </tr>
      </template>
      <template v-slot:no-data>No data</template>
    </v-data-table>
  </v-card>
</template>

<script>
import fb from "@/firebase";
//import { mapMutations } from "vuex";

import CreditNotesInfo from "@/components/CreditNotesInfo";

export default {
  name: "ProfileInvoices",
  components: {},
  props: {
    uid: String
  },
  data: () => ({
    invoices: [],
    loading: false,
    headers: [
      { text: "ID", value: "id" },
      { text: "Invoice number", value: "invoice number" },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Creation date", value: "created", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ]
  }),
  methods: {
    invoicePdf(item) {
      window.open(item.invoice_pdf, "CNN_WindowName");
    },
    creditNotes(id) {
      this.$modal.show(
        CreditNotesInfo,
        {
          invoiceId: id
        },
        {
          height: "auto",
          width: "85%",
          minWidth: 500,
          maxWidth: 1100,
          scrollable: true
        }
      );
    }
  },
  mounted() {
    fb.db
      .collection("stripe_customers")
      .doc(`${this.uid}`)
      .collection("invoices")
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          this.invoices.push(doc.data());
        });
      });
  },
  watch: {}
};
</script>
